export default __webpack_public_path__ + "static/media/bg.7eae4995.jpg";